import * as React from 'react';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { EFacilityType, JsonQuery, NonEmptyArray } from '../../../../packages/JsonQuery';
import { LivingConditions } from '../../components/LivingConditions';

interface ILivingConditionsContainerProps {
  contentPadding?: boolean;
}

export const LivingConditionsContainer: React.FC<ILivingConditionsContainerProps> = ({ contentPadding = true }) => {
  const { jsonQuery, onChange } = useFiltersContext();
  const livingConditions = new JsonQuery(jsonQuery).getLivingConditions();

  const handleChange = React.useCallback(
    (condition: EFacilityType, value: boolean) => {
      let newLivingConditions: NonEmptyArray<EFacilityType> | null;

      if (value) {
        newLivingConditions = [...(livingConditions || []), condition];
      } else {
        const filteredLivingConditions = livingConditions?.filter(i => i !== condition);
        newLivingConditions = filteredLivingConditions?.length
          ? (filteredLivingConditions as NonEmptyArray<EFacilityType>)
          : null;
      }

      onChange({ action: 'setLivingConditions', arguments: [newLivingConditions] });
    },
    [onChange, livingConditions],
  );

  return <LivingConditions value={livingConditions} onChange={handleChange} contentPadding={contentPadding} />;
};
